import React from 'react'
import styled from 'styled-components'

const Div = styled.div`
    border-bottom: 0.5px solid #E4E7E7;
    display: flex;
    padding: 16px 0;
    justify-content: space-between;
`

const T = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #626A6A;
    text-transform: capitalize;
`

const V = styled(T)`
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
    color: #081717;
    text-align: right;
`

const Attribute = ({title, value, subtitle, subtitle2}) => (
    <Div>
        <div>
            <T>{title}</T>
            {subtitle && <T style={{ fontSize: '12px'}}>{subtitle}</T>}
        </div>
        <div>
            <V>{value}</V>
            {subtitle2 && <T style={{ fontSize: '12px', textAlign: 'right'}}>{subtitle2}</T>}
        </div>
    </Div>
) 

export default Attribute